import withIntermediaClient from '../../lib/withIntermediaClient';
import TriviaCarousel from './TriviaCarousel';

const triviaCarouselContainer = withIntermediaClient(TriviaCarousel);

export default triviaCarouselContainer;
